(function () {
  if (window.pdCharge) return;
  window.pdCharge = true;
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Échange animé sur le terrain ---------- */
  function initTerrain(scene) {
    if (scene.dataset.pdInit) return;
    scene.dataset.pdInit = '1';
    var terrain = scene.querySelector('.pd-terrain');
    var balle = scene.querySelector('.pd-balle');
    var ombre = scene.querySelector('.pd-ombre');
    var impact = scene.querySelector('.pd-impact');
    var traces = Array.prototype.slice.call(scene.querySelectorAll('.pd-trace'));
    var histo = [];
    var baseX = 58, baseZ = -28;

    // x, y en fraction du terrain (y=0 vitre du fond, y=1 vitre avant), z = hauteur en px
    function nouvelEchange() {
      var a = 0.25 + Math.random() * 0.5, b = 0.2 + Math.random() * 0.6;
      return [
        { x: a, y: 0.92, z: 30, d: 0 },
        { x: 1 - b, y: 0.22, z: 0, d: 900, type: 'rebond', arc: 70 },
        { x: 1 - b - 0.06, y: 0.0, z: 45, d: 320, type: 'vitre', arc: 12 },
        { x: 1 - b, y: 0.12, z: 26, d: 300, arc: 8 },
        { x: b, y: 0.76, z: 0, d: 900, type: 'rebond', arc: 70 },
        { x: b + 0.08, y: 1.0, z: 40, d: 320, type: 'vitre', arc: 12 },
        { x: a, y: 0.92, z: 30, d: 300, arc: 8 }
      ];
    }

    var points = nouvelEchange(), seg = 1, debut = null, actif = true;

    function place(x, y, z) {
      var w = terrain.clientWidth, h = terrain.clientHeight;
      var px = x * w, py = y * h;
      balle.style.transform = 'translate3d(' + px + 'px,' + py + 'px,' + z + 'px)';
      ombre.style.transform = 'translate3d(' + px + 'px,' + py + 'px,0) scale(' + Math.max(0.4, 1 - z / 120) + ')';
      ombre.style.opacity = Math.max(0.12, 1 - z / 80);
      histo.unshift([px, py, z]);
      if (histo.length > 12) histo.pop();
      traces.forEach(function (t, i) {
        var p = histo[(i + 1) * 2] || histo[histo.length - 1];
        t.style.transform = 'translate3d(' + p[0] + 'px,' + p[1] + 'px,' + p[2] + 'px) scale(' + (0.9 - i * 0.16) + ')';
        t.style.opacity = (0.32 - i * 0.07).toFixed(2);
      });
    }

    function marqueImpact(p) {
      impact.style.left = (p.x * 100) + '%';
      impact.style.top = (p.y * 100) + '%';
      impact.classList.remove('is-on');
      void impact.offsetWidth;
      impact.classList.add('is-on');
    }

    function boucle(t) {
      if (!actif) return;
      if (debut === null) debut = t;
      var p0 = points[seg - 1], p1 = points[seg];
      var k = Math.min(1, (t - debut) / p1.d);
      var x = p0.x + (p1.x - p0.x) * k;
      var y = p0.y + (p1.y - p0.y) * k;
      var z = p0.z + (p1.z - p0.z) * k + (p1.arc || 0) * 4 * k * (1 - k);
      place(x, y, z);
      if (k >= 1) {
        if (p1.type) marqueImpact(p1);
        seg++;
        debut = t;
        if (seg >= points.length) { points = nouvelEchange(); seg = 1; }
      }
      requestAnimationFrame(boucle);
    }

    if (reduit) {
      place(0.5, 0.7, 0);
      return;
    }

    // Démarre seulement quand le terrain est visible, s'arrête hors écran
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting && !actif) { actif = true; debut = null; requestAnimationFrame(boucle); }
        if (!e.isIntersecting) actif = false;
      });
    });
    obs.observe(scene);
    requestAnimationFrame(boucle);

    scene.addEventListener('pointermove', function (e) {
      var r = scene.getBoundingClientRect();
      var dx = (e.clientX - r.left) / r.width - 0.5;
      var dy = (e.clientY - r.top) / r.height - 0.5;
      terrain.style.transform = 'rotateX(' + (baseX - dy * 8) + 'deg) rotateZ(' + (baseZ + dx * 14) + 'deg)';
    });
    scene.addEventListener('pointerleave', function () {
      terrain.style.transform = '';
    });
    scene.addEventListener('click', function () {
      points = nouvelEchange(); seg = 1; debut = null;
    });
  }

  /* ---------- Configurateur « Trouve ta raquette » ---------- */
  var FORMES = {
    ronde: {
      nom: 'Raquette ronde',
      texte: 'Le contrôle avant tout : grande zone de frappe, équilibre vers le manche, des coups plus faciles à placer.',
      d: 'M50 6 C77 6 94 28 94 56 C94 86 74 108 50 108 C26 108 6 86 6 56 C6 28 23 6 50 6 Z',
      equilibre: 'Bas'
    },
    goutte: {
      nom: 'Raquette goutte d\u2019eau',
      texte: 'Le compromis : assez de contrôle pour défendre, assez de puissance pour conclure au filet.',
      d: 'M50 4 C80 4 95 26 93 54 C91 84 72 104 50 110 C28 104 9 84 7 54 C5 26 20 4 50 4 Z',
      equilibre: 'Moyen'
    },
    diamant: {
      nom: 'Raquette diamant',
      texte: 'La puissance : équilibre vers la tête, frappes lourdes au smash. Exigeante, pour les joueurs confirmés.',
      d: 'M50 2 C64 14 88 30 92 46 C95 72 76 100 50 110 C24 100 5 72 8 46 C12 30 36 14 50 2 Z',
      equilibre: 'Haut'
    }
  };

  function initFinder(root) {
    if (root.dataset.pdInit) return;
    root.dataset.pdInit = '1';
    var form = root.querySelector('form');
    var res = root.querySelector('.pd-resultat');
    var tete = res.querySelector('.pd-tete');
    var liens = JSON.parse(root.querySelector('[data-pd-liens]').textContent || '{}');

    function calcule() {
      var niveau = (form.elements.niveau || {}).value;
      var style = (form.elements.style || {}).value;
      var bras = (form.elements.bras || {}).value;
      var forme = 'goutte';
      if (niveau === 'debut' || style === 'defense' || bras === 'sensible') forme = 'ronde';
      else if (niveau === 'competition' && style === 'attaque') forme = 'diamant';
      var poids = '355 à 365 g';
      if (bras === 'sensible') poids = '345 à 355 g';
      else if (niveau === 'competition') poids = '360 à 375 g';
      var mousse = (bras === 'sensible' || niveau === 'debut') ? 'EVA souple' : (forme === 'diamant' ? 'EVA dure' : 'EVA mi-dure');
      return { forme: forme, poids: poids, mousse: mousse };
    }

    function maj() {
      var r = calcule(), f = FORMES[r.forme];
      tete.setAttribute('d', f.d);
      res.querySelector('[data-pd="forme"]').textContent = f.nom;
      res.querySelector('[data-pd="texte"]').textContent = f.texte;
      res.querySelector('[data-pd="poids"]').textContent = r.poids;
      res.querySelector('[data-pd="equilibre"]').textContent = f.equilibre;
      res.querySelector('[data-pd="mousse"]').textContent = r.mousse;
      var lien = res.querySelector('[data-pd="lien"]');
      lien.href = liens[r.forme] || liens.defaut || '/collections/all';
      lien.textContent = 'Voir les raquettes ' + (r.forme === 'goutte' ? 'goutte d\u2019eau' : r.forme + 's');
      res.classList.remove('is-maj'); void res.offsetWidth; res.classList.add('is-maj');
    }

    form.addEventListener('change', maj);
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    maj();
  }

  /* ---------- Onglets de la grille ---------- */
  function initOnglets(root) {
    if (root.dataset.pdInit) return;
    root.dataset.pdInit = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function choisir(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        root.querySelector('#' + t.getAttribute('aria-controls')).hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { choisir(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') choisir(tabs[(i + 1) % tabs.length], true);
        if (e.key === 'ArrowLeft') choisir(tabs[(i - 1 + tabs.length) % tabs.length], true);
      });
    });
  }

  function initTout() {
    document.querySelectorAll('.pd-scene').forEach(initTerrain);
    document.querySelectorAll('.pd-finder').forEach(initFinder);
    document.querySelectorAll('.pd-grille').forEach(initOnglets);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTout);
  else initTout();
  // Éditeur de thème : réinitialise quand une section est rechargée
  document.addEventListener('shopify:section:load', initTout);
})();
